'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["role", "listStyleReset", "condensedAll", "condensed"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { rootStyle } from "../../styles/index.mjs";
import styled, { css } from "../../styled-components.mjs";
var TypeListElement = styled.ul.withConfig({
  displayName: "TypeList__TypeListElement",
  componentId: "sc-1jhixr6-0"
})(["", ";padding-inline-start:", ";padding-inline-end:0;padding-block-end:", ";margin-block-start:0;margin-block-end:0;overflow-wrap:break-word;", ";"], rootStyle(), function (props) {
  return props.$condensedAll ? '0' : '32px';
}, function (props) {
  return props.$condensed && '0';
}, function (props) {
  return props.$listStyleReset !== false && css(["list-style-type:none;"]);
});
var TypeListComponent = /*#__PURE__*/React.forwardRef(function TypeList(_ref, ref) {
  var _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'list' : _ref$role,
    _ref$listStyleReset = _ref.listStyleReset,
    listStyleReset = _ref$listStyleReset === void 0 ? false : _ref$listStyleReset,
    condensedAll = _ref.condensedAll,
    condensed = _ref.condensed,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(TypeListElement, Object.assign({
    role: role,
    ref: ref,
    $listStyleReset: listStyleReset,
    $condensedAll: condensedAll,
    $condensed: condensed
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.TypeList
  }));
});
var typeListHelpers = {
  /**
   * @deprecated
   * Use `<TypeList />` instead (it's a `ul` element by default).
   */
  ul: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeListComponent, Object.assign({
      ref: ref
    }, props));
  }),
  /**
   * @deprecated
   * Use `<TypeList as="ol" />` instead.
   */
  ol: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeListComponent, Object.assign({
      as: "ol",
      ref: ref
    }, props));
  })
};

/**
 * TypeList displays child TypeListItems in a simple vertical list.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-typelist--docs) |
 * [Encore site](https://encore.spotify.net/web/components/text#text-lists) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TypeList)
 */
export var TypeList = Object.assign(TypeListComponent, typeListHelpers);